import { Tags } from '@/features/tags';
import { Cortex } from '@/features/cortex';
import { Library } from '@/features/library';
import { SettingsNav } from '@/features/settings';

import { useRouteInfo } from '@/hooks/use-route-info';

export const AsideContent = () => {
  const { isHome, isTags, isLibrary, isCortex, isSettings } = useRouteInfo();

  const renderContent = () => {
    switch (true) {
      case isHome:
      case isLibrary:
        return <Library />;
      case isCortex:
        return <Cortex />;
      case isTags:
        return <Tags />;
      case isSettings:
        return <SettingsNav />;
      default:
        return null;
    }
  };

  return <>{renderContent()}</>;
};
